import { ErrorBoundary } from 'react-error-boundary'
import PageErrorFallback from '@/components/PageErrorFallback'
import { ComponentFile } from '../types'

type PageProps = {
  page: ComponentFile
  layouts: ComponentFile[]
  inertiaKey: any
  props: any
}

const Page = ({ page, layouts, inertiaKey, props }: PageProps) => {
  return layouts.reduceRight(
    (acc, Layout) => <Layout.default {...props}>{acc}</Layout.default>,
    <ErrorBoundary
      key={inertiaKey}
      fallback={<PageErrorFallback withUseErrorBoundary />}
      onError={(error, info) => {
        console.error('ErrorBoundary caught an error', { error, info, props })
      }}
    >
      <page.default key={inertiaKey} {...props} />
    </ErrorBoundary>,
  )
}

export default Page
